var Backbone,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

require('../../../../modules/shared/frontend/helpers/json_response_handler');

Backbone = require('backbone');

Backbone.$ = $;

Modules.EmailSubscription.Models.Subscription = (function(superClass) {
  extend(Subscription, superClass);

  function Subscription() {
    return Subscription.__super__.constructor.apply(this, arguments);
  }

  Subscription.prototype.parse = function(res) {
    var error, result;
    if (Modules.Shared.Helpers.JsonResponseHandler.loginRequired(res)) {
      return;
    }
    error = res.error, result = res.result;
    if ((error != null) && (error.code != null) || result !== 'ok') {
      this.trigger('subscribe:error', error);
    } else {
      this.trigger('subscribe:success');
    }
    return false;
  };

  return Subscription;

})(Backbone.Model);

module.exports = Modules.EmailSubscription.Models.Subscription;

